// @ts-nocheck
import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useToast } from 'hooks';
import { API_URL, APPROVE_REJECT_API } from './apiConfig';
import useStatusConfirm from './useStatusConfirm';
import useClientAccessDaywork from './useClientAccessDaywork';

const useRejectApproveConfirm = (location, address) => {
  const toast = useToast();

  const locationRef = useRef(location);
  const { pdfData } = useClientAccessDaywork();

  useEffect(() => {
    locationRef.current = location;
  }, [location]);
  const { keyParam, isExpired } = useStatusConfirm();
  const [open, setOpen] = useState(false);
  const [isRejected, setIsRejected] = useState(false);
  const [isApproved, setIsApproved] = useState(false);
  const [rejectedMessage, setRejectedMessage] = useState('');
  const [approvalMessage, setApprovalMessage] = useState('');
  const [comment, setComment] = useState('');
  const [signatoryName, setSignatoryName] = useState();

  useEffect(() => {
    const clientSignatoryName =
      pdfData?.length > 0 ? pdfData?.[0]?.signatory_name : null;
    if (clientSignatoryName) {
      setSignatoryName(clientSignatoryName);
    }
  }, [pdfData]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // Function to simulate approving or rejecting a document
  const approveRejectDocument = async (isDwdApproved, rejectedReason) => {
    if (!signatoryName) {
      toast.error('Signatory name is required.');
      return;
    }
    try {
      const requestBody = {
        key: keyParam,
        is_approved: isDwdApproved,
        rejected_reason: rejectedReason,
        latitude: locationRef?.current?.coords?.latitude || null,
        longitude: locationRef?.current?.coords?.longitude || null,
        address_line: address,
        comment,
        signatory_name: signatoryName,
      };

      // Make a POST request to the APPROVE_REJECT_API
      const response = await axios.post(
        `${API_URL}${APPROVE_REJECT_API}`,
        requestBody,
      );

      setRejectedMessage(response?.data?.message);

      // Log response or handle success
      setIsRejected(true);
    } catch (error) {
      console.error('Error rejecting document:', error);
    }
  };

  // Function to simulate approving or rejecting a document
  const handleApproved = async (isDwdApproved, signatureId) => {
    try {
      const requestBody = {
        key: keyParam,
        signature_id: signatureId,
        is_approved: isDwdApproved,
        comment,
        signatory_name: signatoryName,
      };

      // Make a POST request to the APPROVE_REJECT_API
      const response = await axios.post(
        `${API_URL}${APPROVE_REJECT_API}`,
        requestBody,
      );

      setApprovalMessage(response?.data?.message);

      // Log response or handle success
      setIsApproved(true);

      handleClose();
    } catch (error) {
      toast.error('Document approval unsuccessful');
    }
  };

  return {
    isExpired,
    isRejected,
    setIsRejected,
    isApproved,
    open,
    handleClose,
    handleClickOpen,
    handleApproved,
    approveRejectDocument,
    rejectedMessage,
    approvalMessage,
    comment,
    setComment,
    signatoryName,
    setSignatoryName,
  };
};

export default useRejectApproveConfirm;
